import ImportImages from '@src/importImages';

const P100_1 = ImportImages('/ouraircraft/p100/1.jpg');
const P100_2 = ImportImages('/ouraircraft/p100/2.jpg');
const P100_3 = ImportImages('/ouraircraft/p100/3.jpg');
const P100_4 = ImportImages('/ouraircraft/p100/4.jpg');
const P100_6 = ImportImages('/ouraircraft/p100/6.jpg');
const P100_8 = ImportImages('/ouraircraft/p100/5.jpg');
const P100_7 = ImportImages('/ouraircraft/p100/7.jpg');

const P100Performance = ImportImages('/ouraircraft/p100.png');
const P100RangeMap = ImportImages('/ouraircraft/p100/P100_RangeMap.png');
const P100Lopa = ImportImages('/ouraircraft/p100/P100_Lopa.png');

const P100DEtails = {
  header: 'Phenom 100',
  content:
    'This four-passenger jet is one of our favorites. Unparalleled performance, intuitive avionics,' +
    ' enhanced safety and a cabin bathed in beautiful natural light.',
  images: [P100_1, P100_2, P100_3, P100_4, P100_6, P100_8, P100_7],
  overview: [
    {
      title: 'Crew',
      content: '2 pilots'
    },
    {
      title: 'Passenger Capacity',
      content: '4 passengers'
    },
    {
      title: 'Cabin Length',
      content: '11 ft'
    },
    {
      title: 'Cabin Height',
      content: '5ft'
    },
    {
      title: 'Cabin Width',
      content: '5ft 1in'
    },
    {
      title: 'Baggage Capacity',
      content: '71ft<sup>3</sup>'
    }
  ],
  performance: P100Performance,
  rangeMap: P100RangeMap,
  lopa: P100Lopa
};

export default P100DEtails;



// WEBPACK FOOTER //
// ./src/components/OurAircraft/P100Details.js